import React, { useState, useEffect, useRef } from "react";
import { Input, InputGroup } from "reactstrap";
import { t } from "i18next";

const SearchBar = ({
  onSearch,
  placeholder = "Search...",
  debounceMs = 500,
  disabled = false,
  submitMode = false,
}) => {
  const [searchTerm, setSearchTerm] = useState("");
  const onSearchRef = useRef(onSearch);

  useEffect(() => {
    onSearchRef.current = onSearch;
  }, [onSearch]);

  // Debounced search for non-submit mode; onSearch kept in a ref so parent
  // re-renders do not reset the timer.
  useEffect(() => {
    if (submitMode) return;

    const timer = setTimeout(() => {
      onSearchRef.current(searchTerm);
    }, debounceMs);

    return () => clearTimeout(timer);
  }, [searchTerm, debounceMs, submitMode]);

  const commitSearch = () => {
    onSearchRef.current(searchTerm);
  };

  const clearSearch = () => {
    setSearchTerm("");
    onSearchRef.current("");
  };

  return (
    <div className="mb-0 flex-grow-1">
      <InputGroup className="flex-grow-1">
        <div className="position-relative flex-grow-1">
          <Input
            type="text"
            placeholder={t(placeholder)}
            value={searchTerm}
            onChange={(e) => setSearchTerm(e.target.value)}
            onKeyDown={(e) => {
              if (submitMode && e.key === "Enter") {
                e.preventDefault();
                commitSearch();
              }
            }}
            className="form-control"
            style={{ paddingRight: searchTerm ? "1.75rem" : undefined }}
            disabled={disabled}
          />
          {searchTerm && (
            <button
              type="button"
              onClick={clearSearch}
              disabled={disabled}
              aria-label={t("Clear")}
              className="btn border-0 p-0 position-absolute text-muted"
              style={{
                right: "0.5rem",
                top: "50%",
                transform: "translateY(-50%)",
                fontSize: "0.9rem",
                zIndex: 2,
              }}
            >
              <i className="ri-close-line"></i>
            </button>
          )}
        </div>
        {submitMode && (
          <button
            className="btn btn-outline-primary d-flex align-items-center justify-content-center"
            type="button"
            onClick={commitSearch}
            disabled={disabled}
            style={{ padding: "0.375rem 0.75rem", height: "100%" }}
            aria-label={t("Search")}
          >
            <i className="ri-search-line"></i>
          </button>
        )}
      </InputGroup>
    </div>
  );
};

export default SearchBar;
